/* @refresh reload */
import '@forest/shared/polyfills'

import './setup'

import './index.css'

import { QueryClientProvider } from '@tanstack/solid-query'
import { render } from 'solid-js/web'
import { App } from './app'
import { shouldMockAPI } from './lib/params'
import { queryClient } from './lib/query-client'

async function enableMocking() {
  const { worker } = await import('./mocks')
  return worker.start({ onUnhandledRequest: 'bypass' })
}

function renderApp() {
  render(
    () => (
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    ),
    document.getElementById('root')!,
  )
}

if (import.meta.env.DEV && shouldMockAPI) {
  enableMocking().then(renderApp)
} else {
  renderApp()
}
